import axios from '@app/config/axios.config';

export async function uploadPotentielsCsvFile({
    filename,
    fileBase64,
    mandatId,
}: {
    filename: string;
    fileBase64: string;
    mandatId: number;
}) {
    return axios.post('/potentiels-csv-file', {
        filename,
        fileBase64,
        mandatId,
    });
}

export async function getPotentielsCsvFilesByMandat(mandatId: number) {
    return axios.get(`/potentiels-csv-file/mandat/${mandatId}`);
}

export async function deletePotentielsCsvFile(id: number) {
    return axios.delete(`/potentiels-csv-file/${id}`);
}

export async function getMandatsWithUnassignedCsv() {
    return axios.get('/potentiels-csv-file/mandats-with-unassigned-csv');
}

export async function assignCollaborateurToCsv(
    csvId: number,
    userLoginId: number,
    archived?: boolean
) {
    return axios.patch(`/potentiels-csv-file/${csvId}/assign`, {
        userLoginId,
        archived,
    });
}

export async function previewPotentielsCsvFile(csvId: number) {
    return axios.get(`/potentiels-csv-file/${csvId}/preview`);
}
